import {
  login,
  logout,
  getInfo,
  dingLogin,
  kuaJieLogin,
  deFengLogin
} from '@/api/user.js'
import {
  getToken,
  setToken,
  removeToken
} from '@/utils/auth'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    ps: '',
    button_permissions: {},
    getToken: 'Bearer ' + getToken(),
    user: {},
    companyName: '',
    toolConfig: {}
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_PS: (state, ps) => {
    state.ps = ps
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USERID: (state, id) => {
    state.user_id = id
  },
  SET_BUTTON_PERMISSIONS: (state, buttonPermissions) => {
    state.button_permissions = buttonPermissions
  },
  // 设置用户
  SET_USER: (state, user) => {
    state.user = user
  },
  SET_COMPANY_NAME: (state, name) => {
    state.companyName = name
  },
  SET_TOOL_CONFIG: (state, toolConfig) => {
    state.toolConfig = toolConfig
  }
}

const actions = {

  getButtonPermissions({ commit }, data) {
    return new Promise(resolve => { // must remove  token  first
      commit('SET_BUTTON_PERMISSIONS', data)
    })
  },

  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const data = response
        commit('SET_TOKEN', data.token)
        setToken(data.token, data.is_test)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user Token
  getTokenVuex({ commit }, data) {
    return new Promise(resolve => { // must remove  token  first
      commit('SET_TOKEN', data)
    })
  },

  setToken({ commit }, data) {
    commit('SET_TOKEN', data)
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const user = response.data.user
        // 清除缓存
        if (!user) {
          resolve('验证失败，请重新登录。')
        }
        const { basic, permission, toolConfig } = user

        commit('SET_USERID', basic.id)
        commit('SET_NAME', basic['c_name'])
        commit('SET_AVATAR', basic.avatar)
        commit('SET_BUTTON_PERMISSIONS', permission)
        commit('SET_USER', basic)
        commit('SET_COMPANY_NAME', basic['company_name'])
        commit('SET_TOOL_CONFIG', toolConfig)
        resolve(user)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        removeToken() // 必须先删除令牌
        commit('RESET_STATE')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },
  dingLogin({ commit }, codeInfo) {
    return new Promise((resolve, reject) => {
      dingLogin(codeInfo).then(response => {
        const data = response
        commit('SET_TOKEN', data.token)
        setToken(data.token, data.is_test)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  dingKuaJieLogin({ commit }, codeInfo) {
    return new Promise((resolve, reject) => {
      kuaJieLogin(codeInfo).then(response => {
        const data = response
        commit('SET_TOKEN', data.token)
        setToken(data.token, data.is_test)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  dingDfLogin({ commit }, codeInfo) {
    return new Promise((resolve, reject) => {
      deFengLogin(codeInfo).then(response => {
        const data = response
        commit('SET_TOKEN', data.token)
        setToken(data.token, data.is_test)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
